export default __webpack_public_path__ + "static/media/5536-karsun.91cddae7.pdf";